import { render, staticRenderFns } from "./HotelCardsWrapper.vue?vue&type=template&id=74e3c4d9&scoped=true&"
import script from "./HotelCardsWrapper.vue?vue&type=script&lang=ts&"
export * from "./HotelCardsWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./HotelCardsWrapper.vue?vue&type=style&index=0&id=74e3c4d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e3c4d9",
  null
  
)

export default component.exports